import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgentService } from 'src/app/core/services/agents/agents.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-otp-verfication',
  templateUrl: './otp-verfication.component.html',
  styleUrls: ['./otp-verfication.component.scss']
})
export class OtpVerficationComponent implements OnInit, OnDestroy, AfterViewInit {
 @ViewChildren('otp1, otp2, otp3, otp4, otp5, otp6') otpInputs!: QueryList<ElementRef>;
  
  otpValues: string[] = ['', '', '', '', '', ''];
  isOtpComplete = false;
  canResend = false;
  resendTimeLeft = 60;
  minutes = 10;
  seconds = 0;
  timerInterval: any;
  resendInterval: any;

  constructor(
    public dialogRef: MatDialogRef<OtpVerficationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _agentService: AgentService,
    private _toaster: ToasterService
  ) {}

  ngOnInit(): void {
    
    console.log(this.data);
    this.startTimer();
    this.startResendTimer();
    this.getOTP();
  }

  getOTP(){
    let payload = {
      phoneNo: this.data.agentPhone,
      "tenantId": environment.tenant.toString(),
      "tenantName": "GASPL"
    }
    this._agentService.getOTPAgents(payload)
    .subscribe((v)=>{
       if(v?.data?.status == false){
         this._toaster.showError('Sorry!',v?.data?.message);
       }
    })
   
  }

  ngAfterViewInit(): void {
    // Set focus to first input after view is initialized
    setTimeout(() => {
      if (this.otpInputs && this.otpInputs.first) {
        this.otpInputs.first.nativeElement.focus();
      }
    }, 100);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
    clearInterval(this.resendInterval);
  }

  onKeyUp(event: KeyboardEvent, index: number, nextInput?: any): void {
    const input = event.target as HTMLInputElement;
    
    // Handle backspace - move to previous input
    if (event.key === 'Backspace') {
      if (input.value === '' && index > 0) {
        const prevInput = this.otpInputs.toArray()[index - 1].nativeElement;
        prevInput.focus();
        prevInput.select();
      }
      return;
    }
    
    // Only allow digits
    if (!/^\d$/.test(input.value)) {
      input.value = '';
      return;
    }
    
    // Update the OTP value
    this.otpValues[index] = input.value;
    
    // Auto-move to next input
    if (input.value !== '' && nextInput) {
      nextInput.nativeElement.focus();
    }
    
    // Check if OTP is complete
    this.checkOtpComplete();
  }

  // Handle paste event for OTP
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;
    
    const pastedText = clipboardData.getData('text').trim();
    
    // Check if pasted content is numeric and of correct length
    if (/^\d+$/.test(pastedText)) {
      const digits = pastedText.split('').slice(0, 6);
      
      // Fill inputs with pasted digits
      this.otpInputs.forEach((input, index) => {
        if (index < digits.length) {
          const inputElement = input.nativeElement as HTMLInputElement;
          inputElement.value = digits[index];
          this.otpValues[index] = digits[index];
        }
      });
      
      // Set focus to the appropriate input
      if (digits.length < 6) {
        this.otpInputs.toArray()[digits.length].nativeElement.focus();
      } else {
        // Remove focus if all inputs are filled
        (document.activeElement as HTMLElement).blur();
        this.checkOtpComplete();
      }
    }
  }

  checkOtpComplete(): void {
    this.isOtpComplete = this.otpValues.every(val => val.length === 1);
  }

  startTimer(): void {
    this.timerInterval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else {
        if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        } else {
          clearInterval(this.timerInterval);
          // Handle OTP expiration
          this.dialogRef.close(false);
        }
      }
    }, 1000);
  }

  startResendTimer(): void {
    this.resendInterval = setInterval(() => {
      if (this.resendTimeLeft > 0) {
        this.resendTimeLeft--;
      } else {
        clearInterval(this.resendInterval);
        this.canResend = true;
      }
    }, 1000);
  }

  resendOtp(): void {
    // Reset the OTP inputs
    this.otpValues = ['', '', '', '', '', ''];
    this.otpInputs.forEach(input => {
      input.nativeElement.value = '';
    });
    this.isOtpComplete = false;
    
    // Focus the first input
    this.otpInputs.first.nativeElement.focus();
    
    // Reset the resend timer
    this.canResend = false;
    this.resendTimeLeft = 60;
    this.startResendTimer();
    this.startTimer();
    this.getOTP();
    
    // Call your service to resend OTP
    // this.authService.resendOtp().subscribe(...);
  }

  verifyOtp(): void {
    const otp = this.otpValues.join('');
    let payload = {
      phoneNo:this.data.agentPhone,
      otp: otp,
      "tenantId": environment.tenant,
      "tenantName": "GASPL"
    }
    this._agentService.checkOTPAgents(payload)
    .subscribe(
      (v)=>{
        if(v?.data?.status == true){
          this.dialogRef.close(true);
        }else{
          // this.dialogRef.close(false);
          this._toaster.showError('Invalid OTP','Please try again');
        }
      },
      (err)=>{
        this.dialogRef.close(false);
      }
    )
    // Call your service to verify OTP
    // this.authService.verifyOtp(otp).subscribe(...);
    
    // For demo purpose, just close the dialog with true
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
